import { createStore } from 'vuex'

export default createStore({
  state: {
    feedback: {
      show: false,
      message: '',
      color: 'success',
      icon: '',
      timeout: 4000
    }
  },
  getters: {
    feedback: (state) => state.feedback,
  },
  mutations: {
    SHOW_FEEDBACK(state, payload) {
      state.feedback.message = payload.message
      state.feedback.color = payload.color || 'success'
      state.feedback.icon = payload.icon || ''
      state.feedback.timeout = payload.timeout || 4000
      state.feedback.show = true
    },
    HIDE_FEEDBACK(state) {
      state.feedback.show = false
    }
  },
  actions: {
    triggerFeedback({ commit }, payload) {
      commit('SHOW_FEEDBACK', payload)
    },
    closeFeedback({ commit }) {
      commit('HIDE_FEEDBACK')
    }
  },
  modules: {
  }
})
